<template>
  <div>
    <input type="checkbox"
      :name="name"
      :value="value"
      :checked="isChecked"
      @change="updateValue" />
    <span class="checkbox-label">{{ labelText }}</span>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
  },
  props: {
    name: {
      type: String,
      required: false,
    },
    value: {
    },
    labelText: {

    },
    checked: {},
  },
  data() {
    return {
      values: [],
    }
  },
  computed: {
    isChecked () {
      return (this.value === this.checked);
    }
  },
  methods: {
    updateValue(e) {
      if (e.target.checked) {
        this.values.push(e.target.value);
      } else {
        this.values = this.values.filter(v => v !== e.target.value);
      }
      this.$emit("check-input", {
        value: e.target.value,
        checked: e.target.checked,
      });
    }
  }
}
</script>

<style scoped>
.checkbox-label {
  white-space: pre-line;
}
</style>